<app-preloader *ngIf="isLoading"></app-preloader>
<div class="modal regionDrmModal">
  <a class="close" (click)="closeModal()">Cerrar</a>
  <h1>{{ isEdit ? 'Editar ' + regionTypeLabel : 'Nueva ' + regionTypeLabel }}</h1>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="formTopRow">
      @if (isEdit) {
        <div class="controlWrapper fieldRegion">
          <label>{{ regionTypeLabel }}</label>
          <span class="readOnly">{{ regionLabel }}</span>
        </div>
        <div class="controlWrapper fieldSegment">
          <label>Unidad de negocio</label>
          <span class="readOnly">{{ selectedSegmentOption?.label }}</span>
        </div>
      } @else {
        <div class="controlWrapper fieldSegment">
          <label>Unidad de negocio<span class="required">*</span></label>
          <app-select
            [options]="segmentOptions"
            placeholder="Seleccione"
            key="label"
            [defaultValue]="segmentSelectDefault"
            (optionSelected)="onSegmentChange($event)"
          ></app-select>
        </div>
        <div class="controlWrapper fieldRegion">
          <label>Número de {{ regionTypeLabel | lowercase }}<span class="required">*</span></label>
          <input type="number" formControlName="regionNumber" min="1" />
        </div>
      }

      <div class="controlWrapper fieldDrm">
        <label>Gerente de ventas (DRM)<span class="required">*</span></label>
        <app-select
          [options]="drmUserOptions"
          placeholder="Seleccione usuario"
          key="label"
          [defaultValue]="drmSelectDefault"
          (optionSelected)="onDrmUserChange($event)"
        ></app-select>
      </div>

      <div class="controlWrapper fieldEnabled">
        <label class="switch">
          <input formControlName="enabled" type="checkbox" />
          <span class="knob"></span>
          <span class="base"></span>
          <span class="description">Habilitado</span>
        </label>
      </div>
    </div>

    <div class="controlWrapper formBranchesRow">
      <label>Sucursales<span class="required">*</span></label>
      <app-taggable-multi-select
        [label]="''"
        [placeholder]="'Seleccione sucursales'"
        [options]="branchOptions"
        [displayKey]="'name'"
        [selectedValues]="getSelectedBranchValues()"
        (selectionChange)="onBranchesChange($event)"
      ></app-taggable-multi-select>
      @if (selectedBranchIds.length === 0 && form.touched) {
        <div class="error"><small>Seleccione al menos una sucursal.</small></div>
      }
    </div>

    <div class="actions">
      <div class="wrapper">
        <button type="button" class="secondary" (click)="closeModal()">Cancelar</button>
        <button type="submit" class="primary" [disabled]="isLoading">
          {{ isEdit ? 'Guardar' : 'Crear' }}
        </button>
      </div>
    </div>
  </form>
</div>
